const MS_PER_MINUTE = 60 * 1000;
const MS_PER_SECOND = 1000;

const DEFAULT_AUTO_LOGOUT_MINUTES = 60;
const DEFAULT_AUTO_LOGOUT_PROMPT_SECONDS = 30;
const MAX_PROMPT_FRACTION_OF_TIMEOUT = 0.5;

type AutoLogoutTiming = {
  timeout: number;
  promptBeforeIdle: number;
};

function positiveNumberOr(raw: string | undefined, fallback: number): number {
  if (!raw?.trim()) return fallback;

  const value = Number(raw);

  return Number.isFinite(value) && value > 0 ? value : fallback;
}

export function getAutoLogoutTiming(
  minutes?: string,
  promptSeconds?: string,
): AutoLogoutTiming {
  const timeout =
    positiveNumberOr(minutes, DEFAULT_AUTO_LOGOUT_MINUTES) * MS_PER_MINUTE;
  const promptBeforeIdle = Math.min(
    positiveNumberOr(promptSeconds, DEFAULT_AUTO_LOGOUT_PROMPT_SECONDS) *
      MS_PER_SECOND,
    timeout * MAX_PROMPT_FRACTION_OF_TIMEOUT,
  );

  return { timeout, promptBeforeIdle };
}
